import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSortBy, useTable, usePagination } from "react-table";
import {
  add_icon,
  barcode_icon,
  filter_icon,
  search_icon,
  substract_icon,
  view_order_icon,
} from "../../assets";
import { Button, Modal, Select, Space } from "antd";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { GetStoreOrders } from "../../Api";
import { PosOrderLines } from "../../Api";
import { fetchStoreOrders } from "../../Redux/Action/orderAction";
import { format } from "date-fns";
import DraftOrdersTable from "./DraftOrdersTable";
import { useSelector, useDispatch } from "react-redux";
import { fetchPosOrderLines } from "../../Redux/Action/orderlinesAction";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import OrderReceiptPDF from "../Order/ordercomponents/OrderReceiptPDF";
import { toast } from "react-toastify";
import { addReturnProducts } from "../../Redux/Action/returnproductAction";
import { clearProducts } from "../../Redux/Action/productsAction";
import Table from "./TableOrder";
import { setCustomer } from "../../Redux/Action/getcustomerAction";
import { setForRefund } from "../../Redux/Action/refundAction";
import ProductList, { InvoiceButton, ResendButton } from "../Order/ProductList";
import Unpaid_Modal from "../Modal/Unpaid_Modal";
import PasswordModal from "../Modal/Password_Modal";
import { verifyPassword } from "../../API/API Functions/ProductRequest_API";
import i18next from "i18next";
import { detectWebDeviceType, isTablet } from "../../utils";

const SESSION_STORAGE_KEY = "products";

const LoadingSpinner = () => {
  return (
    <div
      style={{ zIndex: 100 }}
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 "
    >
      <div className="spinner ">
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
        <span className="me-2.5 "></span>
      </div>
    </div>
  );
};
// export function OrderSearchBar({ setSelectedButton }) {
//   const { t, i18n } = useTranslation();
//   const isRtl = i18n.dir() === "rtl";
//   const dispatch = useDispatch();
//   const ref = useRef(null);

//   const debounce = (func, delay) => {
//     let timer;
//     return function (...args) {
//       const context = this;
//       clearTimeout(timer);
//       timer = setTimeout(() => func.apply(context, args), delay);
//     };
//   };

//   const handleSearchChange = debounce((searchTerm) => {
//     const trimmedSearch = searchTerm.trim();
//     dispatch(fetchStoreOrders(0, trimmedSearch));
//     setSelectedButton("allOrders");
//   }, 500);

//   // const handleSearchChange = (searchTerm) => {
//   //   dispatch(fetchStoreOrders(0, searchTerm));
//   //   setSelectedButton("allOrders");
//   // };

//   useEffect(() => {
//     const handleKeyDown = (event) => {
//       if (event.shiftKey && event.key === "x") {
//         ref.current.focus();
//       }
//     };

//     document.addEventListener("keydown", handleKeyDown);

//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//     };
//   }, [ref]);

//   return (
//     <div className={`relative flex ${isRtl ? "me-8" : "ms-8"} me-8 w-[100%]`}>
//       {isRtl ? (
//         <span className="absolute inset-y-0 right-0 flex items-center pr-3">
//           <img src={search_icon} alt="customers_search_icon" />
//         </span>
//       ) : (
//         <span className="absolute inset-y-0 left-0 flex items-center pl-3">
//           <img src={search_icon} alt="customers_search_icon" />
//         </span>
//       )}
//       <input
//         type="text"
//         ref={ref}
//         placeholder={t("Search receipt number, customer")}
//         className="border p-2 ps-10 rounded w-full focus:outline-none rounded-[6px]"
//         onChange={(e) => {
//           const searchTerm = e.target.value;
//           if (searchTerm.length >= 0) {
//             handleSearchChange(searchTerm);
//           }
//         }}
//       />
//     </div>
//   );
// }

export function OrderSearchBar({ setSelectedButton, pagination, setSearchValue, setType }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const inputRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchType, setSearchType] = useState(null); // "customer", "receipt", "product"
  const [showSuggestions, setShowSuggestions] = useState(false);

  const debounce = (func, delay) => {
    let timer;
    return function (...args) {
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  const triggerSearch = debounce((term, type) => {
    const trimTerm = term.trim();
    if (trimTerm && type) {
      if (type === "customName") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null,type )); // pass as product_name
      } else if (type === "shortCode") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null,type)); // pass as order_ref
      } else if (type === "product") {
        dispatch(fetchStoreOrders(pagination, "", "", trimTerm, null,type)); // pass as product_name
      } else {
        dispatch(fetchStoreOrders(pagination, trimTerm)); // pass as order_ref
      }
      setSelectedButton("allOrders");
    }
  }, 500);

  const suggestions = [
    { type: "customer", label: t("Search by Customer Name / Phone") },
    { type: "receipt", label: t("Search by Receipt No.") },
    { type: "product", label: t("Search by Product") },
    { type: "shortCode", label: t("Search by Short Code") },
    { type: "customName", label: t("Search by Custom Name") },
  ];

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setSearchValue(value)
    setShowSuggestions(!searchType);

    if (searchType) {
      triggerSearch(value, searchType);
    }
  };

  const handleSelectType = (type) => {
    setSearchType(type);
    setType(type);
    setShowSuggestions(false);
    triggerSearch(searchTerm, type);
  };

  const clearFilter = () => {
    setSearchTerm("");
    setSearchValue("")

    setSearchType(null);
    setType(null);
    setShowSuggestions(false);
    dispatch(fetchStoreOrders(pagination, ""));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "x") {
        inputRef.current.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div className={`relative w-full ${isRtl ? "me-8" : "ms-8"} me-8`}>
      {/* Tag with clear filter */}
      {searchType && (
        <div
          className={`${
            isRtl ? "right-0" : "left-0"
          } absolute -top-9 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"`}
        >
          <span className="capitalize">
            {isRtl ? (
              <>
                {/* <strong>{searchTerm}</strong>:  */}
                {t(searchType)}
              </>
            ) : (
              <>
                {t(searchType)}
                {/* : <strong>{searchTerm}</strong> */}
              </>
            )}
          </span>
          <button onClick={clearFilter} className="ms-1 text-xs">
            ❌
          </button>
        </div>
      )}

      {/* Input box */}
      <div className="relative me-2">
        {isRtl ? (
          <span className="absolute inset-y-0 right-0 flex items-center pr-3">
            <img src={search_icon} alt="search" />
          </span>
        ) : (
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <img src={search_icon} alt="search" />
          </span>
        )}

        <input
          type="text"
          ref={inputRef}
          placeholder={t("Search receipt number, customer")}
          className="border p-2 ps-10 rounded w-full focus:outline-none rounded-[6px]"
          value={searchTerm}
          onChange={handleInputChange}
          onFocus={() => !searchType && setShowSuggestions(true)}
        />
      </div>

      {/* Suggestion Dropdown */}
      {showSuggestions && !searchType && searchTerm.length > 0 && (
        <ul className="absolute bg-white border mt-1 rounded shadow z-10 w-full">
          {suggestions.map(({ type, label }) => (
            <li
              key={type}
              className="px-4 py-2 hover:bg-gray-100 border-b-2 text-blue-900 italic cursor-pointer text-sm"
              onClick={() => handleSelectType(type)}
            >
              {label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function AllOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "ms-0" : "ms-6"
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Orders")}</div>
    </div>
  );
}

function RefundedOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Refunded Orders")}</div>
    </div>
  );
}

function UnpaidOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Unpaid Orders")}</div>
    </div>
  );
}

function OrderFromButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "" : ""
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled && showButtons == false
      ? // ? " border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Order From")}</div>
    </div>
  );
}

function ReturnOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  const buttonClasses = `flex cursor-pointer  ${
    isRtl ? "ms-1" : "ms-8"
  } justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    showButtons == true
      ? " border-[#9dd8ff] bg-[#1b4597] text-white "
      : "border-stone-300 bg-white"
  }`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("All Orders")}</div>
    </div>
  );
}

function PaidOrderButton({ onClick }) {
  return (
    <div
      className="flex justify-center px-3 py-2 font-medium  hover:font-semibold text-zinc-800 bg-white  border border-solid border-stone-300 whitespace-nowrap rounded-lg"
      onClick={onClick}
    >
      <div className="mt-0.5 ml-0.5">Paid</div>
    </div>
  );
}

function RefundOrderButton({ onClick }) {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="flex justify-center w-[20vh] h-[10vh] items-center font-semibold  hover:font-semibold text-white bg-[#F42020] border border-solid border-stone-300 whitespace-nowrap rounded-lg cursor-pointer"
      onClick={onClick}
    >
      <div className=" justify-center items-center">{t("Return")}</div>
    </div>
  );
}

function DraftOrderButton({ enabled, onClick, showButtons }) {
  const { t, i18n } = useTranslation();

  const buttonClasses = `flex cursor-pointer justify-center px-3 py-2 font-medium hover:font-semibold text-black border border-solid  whitespace-nowrap rounded-lg ${
    enabled
      ? // ? "border-[#9dd8ff] bg-[#1b4597] text-white"
        "border-[#1b4597] bg-[#1b4597] text-white"
      : "border-stone-300 bg-white"
  } ${showButtons == true ? "ms-48" : "ms-0"}`;

  return (
    <div className={buttonClasses} onClick={onClick}>
      <div className="mt-0.5 ml-0.5">{t("Draft Orders")}</div>
    </div>
  );
}

function OrderSkeleton() {
  return (
    <Stack spacing={1} marginTop={5}>
      {/* <Skeleton variant="text" sx={{ fontSize: '1rem' }} /> */}
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      <Skeleton variant="rectangular" height={60} />
      <Skeleton variant="rectangular" height={5} />
      {/* <Skeleton variant="rectangular" width={210} height={60} /> */}
      {/* <Skeleton variant="rounded" width={385} height={60} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
      <Skeleton variant="rectangular" width={385} height={60} /> */}
    </Stack>
  );
}

function Order_Table() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const dispatch = useDispatch();
  const { orders = [] } = useSelector((state) => state.orders);
  const { orderLines = [] } = useSelector((state) => state.orderlinesReducer);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [pagination, setPagination] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showDraftOrdersTable, setShowDraftOrdersTable] = useState(false);
  const [showOrderTable, setShowOrderTable] = useState(true);
  const { user } = useSelector((state) => state?.login);
  const draftOrders = useSelector((state) => state.draftOrders.draftOrders);
  const [selectedOrderIndex, setSelectedOrderIndex] = useState(-1);
  const [showResendButton, setShowResendButton] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [refundItems, setRefundItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false); // Define loading state
  const [showRefundedOrders, setShowRefundedOrders] = useState(false);
  const [selectedButton, setSelectedButton] = useState("allOrders"); // Track selected button
  const [selectedProductIndex, setSelectedProductIndex] = useState(-1);
  const userData = useSelector((state) => state?.login?.user?.result);
  const [showButtons, setShowButtons] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState('');
  const [isUnpaidModalVisible, setIsUnpaidModalVisible] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState(null);
  const [orderFromOptions, setOrderFromOptions] = useState([]);
  const location = useLocation();
  const forRefund = useSelector((state) => state.refundReducer.forRefund);
  const [isProductSelectionActive, setIsProductSelectionActive] =
    useState(false);
  const closeSession = useSelector(
    (state) => state?.sessionReducer?.closeSession
  );
  const [openPassword, setOpenPassword] = useState(false);
  // const requiredPass = useSelector(
  //   (state) => state?.login?.user?.result?.is_password_restrict
  // );
  const requiredPass = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_password_restrict
  );
  const closePasswordModal = () => setOpenPassword(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOrderFrom, setSelectedOrderFrom] = useState(null);
 const isETAenabled = useSelector(
    (state) => state?.permissionReducer?.permissions?.is_eta_enabled
  );
  useEffect(() => {
    if (location.pathname === "/orders" && location.search === "") {
      setShowButtons(false);
      dispatch(setForRefund(false));
    } else if (
      location.pathname === "/orders" &&
      location.search.includes("refundorder")
    ) {
      setShowButtons(true);
    }
  }, [location]);

  // useEffect(() => {
  //   if (selectedButton === "allOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, ""));
  //   } else if (selectedButton === "refundedOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, "refunded"));
  //   } else if (selectedButton === "unpaidOrders") {
  //     dispatch(fetchStoreOrders(pagination, null, "unpaid"));
  //   }
  // }, [selectedButton, pagination, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoadingData(true);
      getOrderFrom();
      try {
        await dispatch(fetchStoreOrders(pagination, '', '', searchValue, undefined, searchType));
        setLoading(false);
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
        setDrawerOpen(false);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setLoading(false);
      } finally {
        setIsLoadingData(false);
      }
    };

    fetchData();
  }, [dispatch, pagination]);

  useEffect(() => {
    if (orders) {
      setFilteredData(orders);
      if (setSelectedButton === "refunded") {
        setFilteredData(orders);
      }
      if (setSelectedButton === "unpaidOrders") {
        setFilteredData(orders);
      }
      if (setSelectedButton === "orderFrom") {
        setFilteredData(orders);
      }
    }
  }, [orders]);

  const lang = i18n.language;

  const handleRowClick = async (order) => {
    setLoading(true);
    // console.log("HCLALA ");

    setSelectAll(false);
    setRefundItems([]);
    setSelectedProducts({});
    try {
      setSelectedOrder(order);
      setDrawerOpen(true);
      await dispatch(fetchPosOrderLines(order.id, lang));
      setSelectedOrder(order);
      // console.log("HCLALA 2 ");

      navigate(`/orders?orderid=${order.id}`, {
        preventScrollReset: true,
      });
      window.history.pushState({}, "", `/orders?orderid=${order.id}`);
      setShowResendButton(!!order.customer_phone);
    } catch (error) {
      console.error("Error fetching order lines:", error);
    } finally {
      // console.log("HCLALA 3");
      setLoading(false);
    }
  };

  const handleDraftOrderClick = (draftOrder) => {
    setPagination(0);
    setSelectedOrder(draftOrder);
    setDrawerOpen(false);
    setSelectAll(false);
  };

  // console.log("cdsdcdscdsc", orderFromOptions);

  const columns = useMemo(() => {
    const baseColumns = [
      {
        Header: t("Session"),
        accessor: "session",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Receipt No."),
        accessor: "receipt_no",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value}</div>
        ),
      },
      {
        Header: t("Order Date"),
        accessor: "date_order",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">{value}</div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Customer"),
        accessor: "customer_name",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value ? value : "--"}</div>
        ),
      },

      {
        Header: t("No. Of Items"),
        accessor: "items",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">{value}</div>
        ),
        sortType: "alphanumeric",
      },
      {
        Header: t("Total"),
        accessor: "order_value",
        Cell: ({ value }) => (
          <div className="flex-auto max-md:max-w-full">
            {i18n.language === "ar" && value < 0 ? (
              <span> {Math.abs(value).toFixed(2)}- EGP</span>
            ) : (
              <span>{Number(value).toFixed(2)} EGP</span>
            )}
          </div>
        ),
      },

      ...(orderFromOptions?.length > 0
        ? [
            {
              Header: t("Order From"),
              accessor: "order_from",
              Cell: ({ value }) => (
                <div className="my-auto text-ellipsis">
                  {(value === "self_delivery"
                    ? t("Self Delivery")
                    : t(value)) || "--"}
                </div>
              ),
            },
          ]
        : []),

      {
        Header: t("Payment Type"),
        accessor: "payment",
        Cell: ({ value }) => (
          <div className="my-auto text-ellipsis">{value ? t(value) : "--"}</div>
        ),
      },
    ];

    if (!drawerOpen) {
      baseColumns.push({
        Header: t("Status"),
        accessor: "state",
        Cell: ({ row }) => {
          const { state } = row.original;

          const handleStatusClick = (e, order) => {
            e.stopPropagation();
            setSelectedOrderDetails(order);
            setIsUnpaidModalVisible(true);
          };

          if (state === "Unpaid") {
            return (
              <button
                onClick={(e) => handleStatusClick(e, row.original)} // Pass the row data
                className={`px-2 py-0 rounded-lg bg-[#F42020] text-white font-semibold`}
              >
                {t("Unpaid")}
              </button>
            );
          }

          if (state === "Paid") {
            return (
              <button
                // onClick={handleStatusClick}

                className={`px-2 py-0 rounded-lg ${
                  state === "Paid"
                    ? "bg-[#7EC242] text-white font-semibold"
                    : "bg-[#F42020] text-white font-semibold"
                }`}
              >
                {state === "Paid" ? t("Paid") : t("Unpaid")}
              </button>
            );
          } else {
            return null;
          }
        },
      });
    }
    if (!drawerOpen) {
      baseColumns.push({
        Header: " ",
        Cell: ({ row }) => (
          <button
            onClick={() => handleRowClick(row.original)}
            style={{ backgroundColor: "transparent", border: "none" }}
          >
            <img
              src={view_order_icon}
              alt="view_order_icon"
              className={`w-8 h-4 transition-transform transform ${
                i18n.language === "ar" ? "scale-x-[-1]" : ""
              }`}
            />
          </button>
        ),
      });
    }

    return baseColumns;
  }, [drawerOpen, user?.currency, orderFromOptions]);

  const navigate = useNavigate();

  const handleDraftClick = () => {
    setPagination(0);
    setDrawerOpen(false);
    setShowDraftOrdersTable(true);
    setShowOrderTable(false);
    setSelectAll(false);
    setSelectedOrderFrom(null);
    setSelectedButton("draftOrders");
  };

  const handleAllOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedOrderFrom(null);
    setShowRefundedOrders(false);
    setSelectedButton("allOrders");
    await dispatch(fetchStoreOrders(0, null, ""));
    setLoading(false);
  };

  const handleRefundedOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowRefundedOrders(true);
    setDrawerOpen(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedOrderFrom(null);
    setSelectedButton("refundedOrders");
    await dispatch(fetchStoreOrders(0, null, "refunded"));
    setLoading(false);
  };

  const handleUnpaidOrderClick = async () => {
    setPagination(0);
    setLoading(true);
    setShowRefundedOrders(false);
     setDrawerOpen(false);
    setShowDraftOrdersTable(false);
    setShowOrderTable(true);
    setSelectedButton("unpaidOrders");
    setSelectedOrderFrom(null);
    await dispatch(fetchStoreOrders(0, null, "unpaid"));
    setLoading(false);
  };

  const handleOrderFromClick = async () => {
    setPagination(0);
    // Toggle dropdown visibility
    // if (!showDropdown && orderFromOptions.length === 0) {
    // setLoadingOrderFrom(true);
    // const response = await dispatch(fetchOrderFromOptions()); // <- Your API call here
    // setOrderFromOptions(response.payload || []);
    // setLoadingOrderFrom(false);
    // }
    setShowDropdown(!showDropdown);
  };

  const handleOrderFromSelect = async (method) => {
    // Deselect if same
    if (selectedOrderFrom?.id === method.id) {
      setShowDropdown(false);
      return;
      // setSelectedOrderFrom(null);
      // setSelectedButton("orderFrom")
      // await dispatch(fetchStoreOrders(0, null, null)); // no filter
    } else {
      setPagination(0);
      setLoading(true);
      setShowRefundedOrders(false);
      setShowDraftOrdersTable(false);
      setShowOrderTable(true);
      setSelectedOrderFrom(method);
      await dispatch(fetchStoreOrders(0, null, null, "", method.id)); // send selected option
      setLoading(false);
    }
  };

  const getOrderFrom = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post(URLS.ORDER_FROM, {
        user_id: userData?.user_id,
        lang: i18next.language === "ar" ? "ar" : "en_US",
      });

      const posOrderFrom = response?.data?.result?.[0]?.pos_order_from;
      setOrderFromOptions(posOrderFrom);
    } catch (err) {
      console.error(err);
      // setErrorMessage("Failed to fetch order from options.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("orderid");
    if (orderId) {
      const order = orders.find(
        (order) => order.order_id === parseInt(orderId)
      );
      if (order) {
        handleRowClick(order);
      }
    }
  }, [orders]);

  const handleResetClick = async () => {
    const params = new URLSearchParams(window.location.search);
    const orderid = params.get("orderid");
    const order_id = Number(orderid);

    try {
      const response = await axiosInstance.post(URLS.SEND_CUSTOMER_SMS, {
        order_id,
      });

      if (
        response.data &&
        response.data.result &&
        response.data.result.status_code === 200
      ) {
        toast.success(t("Message sent Successfully"));
      } else {
        toast.error(t(response.data.result.status));
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred while sending the message");
    }
  };

  const handleInvoiceClick = async () => {
    const params = new URLSearchParams(window.location.search);
    const orderid = params.get("orderid");
    const order_id = Number(orderid);
    const response = await axiosInstance.post(URLS.RECEIPT_ORDER_DETAILS, {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      order_id,
    });
    if (response) {
      handlePrintInvoice(response?.data?.result);
    }
  };

  let order_page = "order_page";

  const handlePrintInvoice = (data) => {
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(OrderReceiptPDF(data, t, i18n.language, userData, order_page, isETAenabled));
    doc.close();

    iframe.contentWindow.focus();

    setTimeout(() => {
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 1000);
  };
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    setSelectedProducts((prev) => {
      const newSelectedProducts = {};
      const updatedRefundItems = [];

      if (isChecked) {
        orderLines?.forEach((product, index) => {
          const packId = product.pack_id || product.package_id || "";
          const uniqueKey = `${product.product_id}_${packId}_${index}`; // use index if absolutely needed
          const add_qty = packId ? product.qty : product.available_refund_qty;

          if (product.available_refund_qty > 0) {
            newSelectedProducts[uniqueKey] = true;

            updatedRefundItems.push({
              ...product,
              id: product.hamper_id && product?.hamper_id != null ? product.hamper_id : (product.product_id || product.id),
              hamper_id: product.hamper_id,
              quantity: add_qty,
              sale_price: (product.price + (product?.tax_amount ? (product?.tax_amount/product.qty) : 0))  - (product.discount_amount/product.qty),
              pack_id: packId,
              // tax_amount: (product.tax_amount/product.qty) * add_qty,
             discount_amount: (product.discount_amount/product.qty) * add_qty,
            });
            
          }
        });
      } else {
        Object.keys(prev).forEach((productKey) => {
          delete newSelectedProducts[productKey];
        });
      }
            console.log("updatedRefundItems===>",updatedRefundItems);

      setRefundItems(updatedRefundItems);
      return newSelectedProducts;
    });
  };

  const handleProductCheckboxChange = (productId) => (e) => {
    const isChecked = e.target.checked;
    setSelectedProducts((prev) => {
      const newSelectedProducts = { ...prev };
      if (isChecked) {
        newSelectedProducts[productId] = true;
      } else {
        delete newSelectedProducts[productId];
      }
      if (Object.keys(newSelectedProducts).length === 0) {
        setSelectAll(false);
      } else if (
        Object.keys(newSelectedProducts).length === orderLines.length
      ) {
        setSelectAll(true);
      } else if (
        Object.keys(newSelectedProducts).length !== orderLines.length
      ) {
        setSelectAll(false);
      }
      return newSelectedProducts;
    });
  };

  useEffect(() => {
    if (Object.keys(selectedProducts).length === orderLines.length) {
      setSelectAll(true);
    } else if (Object.keys(selectedProducts).length === 0) {
      setSelectAll(false);
    } else if (Object.keys(selectedProducts).length !== orderLines.length) {
      setSelectAll(false);
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (selectAll) {
      const newSelectedProducts = {};
      orderLines.forEach((product) => {
        if (product.available_refund_qty > 0) {
          newSelectedProducts[product.product_id] = true;
        }
      });
      setSelectedProducts(newSelectedProducts);
    } else {
    }
  }, [selectAll]);

  useEffect(() => {
    const availableProducts = orderLines.filter(
      (product) => product.available_refund_qty > 0
    );

    if (availableProducts.length === 0) {
      setSelectAll(false);
    } else {
      const allSelected = availableProducts.every(
        (product) => selectedProducts[product.product_id]
      );
      setSelectAll(allSelected);
    }
  }, [selectedProducts, orderLines]);

  const updateRefundItems = (product, quantity, isSelected) => {
    const updatedRefundItems = [...refundItems];

    const productKey = `${product.id}_${product.pack_id || ""}`;

    // Find using composite key
    const existingProductIndex = updatedRefundItems.findIndex((item) => {
      const itemKey = `${item.id}_${item.pack_id || ""}`;
      return itemKey === productKey;
    });

    if (existingProductIndex !== -1) {
      updatedRefundItems.splice(existingProductIndex, 1);
    }

    if (isSelected) {
      updatedRefundItems.push({
        ...product,
        quantity,
        hamper_id: product.hamper_id,
        id: product.hamper_id && product?.hamper_id != null ? product.hamper_id : (product.product_id || product.id),
        sale_price: (product.rate + (product?.tax_amount ? (product?.tax_amount/product?.quantity) : 0)) - product.discount_amount,
        discount_amount: product.discount_amount * quantity,
        pack_id: product.pack_id, // map for consistency
      });
    }
    setRefundItems(updatedRefundItems);
  };

  useEffect(() => {
    const availableRefundProducts = orderLines.filter(
      (product) => product.available_refund_qty > 0
    );
    if (refundItems.length != availableRefundProducts.length) {
      setSelectAll(false);
    }
    if (refundItems.length === availableRefundProducts.length) {
      setSelectAll(true);
    }
    if (refundItems.length === 0) {
      setSelectAll(false);
    }
  }, [refundItems]);

  const handlePasswordConfirm = async (enteredPassword) => {
    setLoading(true);
    const userId = userData?.user_id;
    const action = "Return Order";

    try {
      const verificationResult = await verifyPassword(
        userId,
        enteredPassword,
        action
      );

      if (
        verificationResult &&
        verificationResult?.result?.status_code === 200
      ) {
        handleReturnClick();
        closePasswordModal();
        setLoading(false);
      } else if (verificationResult?.result?.status_code === 400) {
        toast.error(t("Incorrect password"));
        setLoading(false);
        return;
      }
    } catch (error) {
      console.error("Error verifying password:", error);
    }
  };

  const ReturnButtonClick = () => {
    if (refundItems.length === 0) {
      toast.error(t("Please select a product for return."));
      return;
    }

    if (requiredPass === true) {
      setOpenPassword(true);
    } else {
      handleReturnClick();
    }
  };

  const handleReturnClick = async () => {
    setLoading(true);

    if (selectedOrder) {
      const order_id = selectedOrder.id;

      const uniqueRefundItems = [
        ...new Map(
          refundItems.map((item) => [`${item.id}_${item.pack_id || ""}`, item])
        ).values(),
      ];

      const filteredRefundItems = uniqueRefundItems.filter(
        (item) => item.quantity > 0
      );

      // ✅ Map pack_id to pack_id
      const productsWithOrderId = filteredRefundItems.map((product) => ({
        ...product,
        order_id,
        pack_id: product.pack_id, // ✅ Add this line
      }));
      console.log("productsWithOrderId", productsWithOrderId);

      dispatch(clearProducts());
      dispatch(setCustomer(selectedOrder.customer_phone));
      dispatch(addReturnProducts(productsWithOrderId));
      navigate(`/session?refundorder=${selectedOrder.id}`);
    }
  };

  const areAllProductsRefundedOrNegative = () => {
    return orderLines.every((product) => {
      const productValue = product.available_refund_qty;
      return productValue <= 0;
    });
  };

  useEffect(() => {
    if (closeSession) {
      // console.log("CHALLL GYAAAAA");
      setIsProductSelectionActive(true);
      setSelectedProductIndex(0);
      setSelectedOrderIndex(null);
      setDrawerOpen(false);
    }
  }, [closeSession]);

  const handleKeyDown = useCallback(
    (e) => {
      if (closeSession) {
        return;
      }
      const key = e.key.toLowerCase();
      const normalizedKey =
        {
          "~": "z",
          "ِ": "a",
          "؛": "p",
          "ٌ": "r",
          ء: "x",
          "َ": "q",
          "ُ": "e",
          escape: "escape",
        }[key] || key;

      if (e.shiftKey && normalizedKey === "z") {
        handleDraftClick();
      } else if (e.shiftKey && normalizedKey === "a") {
        handleAllOrderClick();
      } else if (e.shiftKey && normalizedKey === "e") {
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
        setDrawerOpen(false);
      } else if (normalizedKey === "escape") {
        e.preventDefault();
        setDrawerOpen(false);
      } else if (e.shiftKey && normalizedKey === "q") {
        handleRefundedOrderClick();
      } else if (
        normalizedKey === (i18n.language === "ar" ? "arrowleft" : "arrowright")
      ) {
        setIsProductSelectionActive(true);
        setSelectedProductIndex(0);
        setSelectedOrderIndex(null);
      } else if (
        normalizedKey === (i18n.language === "ar" ? "arrowright" : "arrowleft")
      ) {
        setIsProductSelectionActive(false);
        setSelectedOrderIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        setSelectedProductIndex(null);
      }
      if (isProductSelectionActive) {
        if (normalizedKey === "arrowup") {
          e.preventDefault();
          if (selectedProductIndex > 0) {
            setSelectedProductIndex((prevIndex) => prevIndex - 1);
          }
        } else if (normalizedKey === "arrowdown") {
          e.preventDefault();
          if (selectedProductIndex < orderLines.length - 1) {
            setSelectedProductIndex((prevIndex) => prevIndex + 1);
          }
        }
      } else {
        if (showOrderTable && filteredData.length > 0) {
          e.preventDefault();
          if (normalizedKey === "arrowup") {
            setSelectedOrderIndex((prevIndex) => Math.max(prevIndex - 1, 0));
          } else if (normalizedKey === "arrowdown") {
            e.preventDefault();
            setSelectedOrderIndex((prevIndex) =>
              Math.min(prevIndex + 1, filteredData.length - 1)
            );
          } else if (normalizedKey === "enter" && selectedOrderIndex >= 0) {
            const order = filteredData[selectedOrderIndex];
            handleRowClick(order);
          } else if (e.altKey || e.getModifierState("AltGraph")) {
            e.preventDefault();
            handleSelectAll({ target: { checked: !selectAll } });
          } else if (drawerOpen) {
            if (e.shiftKey && normalizedKey === "p") {
              handleInvoiceClick();
            } else if (
              e.shiftKey &&
              normalizedKey === "r" &&
              selectedOrder &&
              selectedOrder.customer_phone &&
              showResendButton
            ) {
              e.preventDefault();
              handleResetClick();
            }
          }
        }
      }
      if (drawerOpen) {
        if (normalizedKey === "enter" && isProductSelectionActive === true) {
          e.preventDefault();
          if (selectedOrder.state === "Unpaid") {
            setIsUnpaidModalVisible(true);
            setSelectedOrderDetails(selectedOrder);
            return; // Do nothing if the order is done
          }
          // handleReturnClick();
          ReturnButtonClick();
        } else if (e.shiftKey && normalizedKey === "l") {
          setIsProductSelectionActive(false);
        }
      }
    },
    [
      showOrderTable,
      filteredData,
      selectedOrderIndex,
      selectedOrder,
      showResendButton,
      handleRowClick,
      handleInvoiceClick,
      handleResetClick,
      handleDraftClick,
      handleAllOrderClick,
      handleSelectAll,
      selectAll,
      orderLines,
      isProductSelectionActive,
    ]
  );

  const [eKeyPressed, setEKeyPressed] = useState(
    localStorage.getItem("eKeyPressed")
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setEKeyPressed(localStorage.getItem("eKeyPressed"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (eKeyPressed !== "true") {
      window.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown, eKeyPressed]);

  // const handlePaymentSuccess = () => {

  //   handleAllOrderClick();

  // };

  const handlePaymentSuccess = () => {
    // Call the function to handle all orders
    handleAllOrderClick();
    setDrawerOpen(false);
    //  handleRowClick();

    // const params = new URLSearchParams(window.location.search);
    // const orderId = params.get("orderid");
    // console.log("ORDERID",orderId);

    // if (orderId) {
    //   const order = orders.find(
    //     (order) => order.order_id === orderId

    //   );
    //   console.log("order",order);

    //   setSelectedOrder(order);
    //   dispatch(fetchPosOrderLines(orderId, lang));
    // Now, check if the orderId is still available
    // }
  };
  const deviceType = detectWebDeviceType();
  return (
    <>
      {loading && <LoadingSpinner />}
      {openPassword === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
          // onCancel={setOpenPassword(false)}
        />
      )}
      {isUnpaidModalVisible && (
        <Unpaid_Modal
          onClose={() => setIsUnpaidModalVisible(false)}
          title="Order Details"
          orderDetails={selectedOrderDetails}
          onPaymentSuccess={handlePaymentSuccess}
        ></Unpaid_Modal>
      )}
      <div className="flex">
        <div
          className={`flex-grow transition-all duration-300 ${
            drawerOpen ? " me-[33%]" : "w-full"
          }`}
        >
          <div
            className={`bg-[#EEEEEE] ${
              deviceType == "tablet" ? "mt-5" : "mt-8"
            }`}
          >
            <div className="flex flex-row bg-[#EEEEEE]">
              <div className={`${isRtl ? "ms-20" : "ms-12"} bg-[#EEEEEE]`}>
                <OrderSearchBar
                  setSelectedButton={setSelectedButton}
                  pagination={pagination}
                  setSearchValue={setSearchValue}
                  setType={setSearchType}
                  // ref={searchInputRef}
                />
              </div>
              {showButtons == false ? (
                <>
                  <div
                    style={{
                      marginRight: i18n.language === "ar" ? 20 : 10,
                      marginLeft: i18n.language === "ar" ? 0 : 20,
                    }}
                  >
                    <AllOrderButton
                      // enabled={showOrderTable}
                      enabled={selectedButton === "allOrders"}
                      onClick={handleAllOrderClick}
                      showButtons={false}
                    />
                  </div>
                  <div style={{ marginRight: 10 }}>
                    <RefundedOrderButton
                      enabled={selectedButton === "refundedOrders"}
                      onClick={handleRefundedOrderClick}
                      showButtons={false}
                    />
                  </div>

                  <div style={{ marginRight: 10 }}>
                    <UnpaidOrderButton
                      enabled={selectedButton === "unpaidOrders"}
                      onClick={handleUnpaidOrderClick}
                      showButtons={false}
                    />
                  </div>

                  <div style={{ marginRight: 10 }}>
                    <DraftOrderButton
                      enabled={
                        showDraftOrdersTable && selectedButton === "draftOrders"
                      }
                      onClick={handleDraftClick}
                      showButtons={false}
                    />
                  </div>

                  {/* <OrderFromButton
                    enabled={selectedButton === "orderFrom"}
                    onClick={handleOrderFromClick}
                    showButtons={false}
                  /> */}

                  {orderFromOptions.length > 0 && (
                    <div className="relative" style={{ marginRight: 10 }}>
                      <OrderFromButton
                        enabled={selectedOrderFrom !== null}
                        onClick={handleOrderFromClick}
                        showButtons={false}
                      />
                      {showDropdown && (
                        <div className="absolute bg-white border rounded shadow mt-2 z-10">
                          {orderFromOptions.map((method) => (
                            <div
                              key={method.id}
                              onClick={() => handleOrderFromSelect(method)}
                              className={`cursor-pointer px-8 py-2 hover:bg-gray-100 ${
                                selectedOrderFrom?.id === method.id
                                  ? "bg-blue-100 font-semibold"
                                  : ""
                              }`}
                            >
                              {method.name === "self_delivery"
                                ? t("Self Delivery")
                                : t(method.name)}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : null}

              {showButtons ? (
                <>
                  <ReturnOrderButton showButtons={showButtons} />
                </>
              ) : null}
            </div>
          </div>

          {showDraftOrdersTable && draftOrders && draftOrders.length === 0 && (
            <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
              <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                {t("No Draft Orders")}
              </p>
            </div>
          )}
          {showOrderTable && filteredData && filteredData.length === 0 && (
            <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm bg-white text-left rounded-[15px] overflow-hidden">
              <p className="text-center py-4 text-lg font-semibold text-zinc-800">
                {t("No Orders")}
              </p>
            </div>
          )}

          {showOrderTable && filteredData && (
            <div className="flex flex-col justify-center mx-20 mt-7 mb-4 pb-2 text-sm bg-white text-left rounded-[15px] overflow-hidden">
              <Table
                columns={columns}
                data={filteredData}
                pagination={pagination}
                isLoadingData={isLoadingData}
                setPagination={setPagination}
                onRowClick={(val) => {
                  navigate(`/orders?orderid=${val?.id}`);
                  handleRowClick(val);
                }}
                selectedRowIndex={selectedOrderIndex}
              />
            </div>
          )}
        </div>
      </div>
      {showDraftOrdersTable && draftOrders && draftOrders.length > 0 ? (
        <div className="flex flex-col justify-center mr-20 ml-20 mt-8 text-sm text-left ">
          <DraftOrdersTable
            draftOrders={draftOrders}
            onRowClick={handleDraftOrderClick}
          />
        </div>
      ) : (
        <>
          {drawerOpen && (
            <div
              className={`fixed  ${
                i18n.language === "ar" ? "left-0" : "right-0"
              } h-[calc(140vh-4rem)] w-[29%] bg-white shadow-lg z-50
                transition-transform duration-300
                ${drawerOpen ? "translate-x-0" : "translate-x-full"} ${
                deviceType == "tablet" ? "top-20" : "top-20"
              }`}
            >
              <div className="flex justify-between px-5 items-center pt-8">
                <h2 className="text-xl font-bold text-blue-900">
                  {t("Receipt No.")} {selectedOrder?.receipt_no}
                </h2>
                <button
                  onClick={() => setDrawerOpen(false)}
                  className="bg-transparent text-gray-500 hover:text-gray-700"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 h-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div className="mt-6 px-5 text-base">
                {selectedOrder?.customer_name && (
                  <p>
                    <strong>{t("Customer Name :")}</strong>{" "}
                    {selectedOrder?.customer_name}
                  </p>
                )}
                {/* {selectedOrder?.customer_phone && (
                  <p>
                    <strong>{t("Customer Phone No.:")}</strong>{" "}
                    {selectedOrder?.customer_phone}
                  </p>
                )} */}
                {selectedOrder?.state === "Unpaid" && (
                  <>
                    <p>
                      <strong>{t("Order Value :")}</strong> EGP{" "}
                      {selectedOrder?.subtotal?.toFixed(2)}
                    </p>
                    <p>
                      <strong>{t("Delivery Fee :")}</strong> EGP{" "}
                      {selectedOrder?.delivery_fee?.toFixed(2)}
                    </p>
                    {selectedOrder?.return_delivery_fee < 0 && (
                      <p>
                        <strong>{t("Refunded Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.return_delivery_fee?.toFixed(2)}
                      </p>
                    )}
                  </>
                )}

                {selectedOrder?.state === "Paid" && (
                  <>
                    <p>
                      <strong>{t("Order Value :")}</strong> EGP{" "}
                      {(
                        Number(selectedOrder?.order_value || 0) +
                        Number(selectedOrder?.total_discount || 0)
                      ).toFixed(2)}
                    </p>

                    {selectedOrder?.total_discount > 0 && (
                      <p>
                        <strong>{t("Total Discount")} :</strong> EGP{" "}
                        {selectedOrder?.total_discount?.toFixed(2)}
                      </p>
                    )}
{selectedOrder?.total_tax_amount > 0 && (
                      <p>
                        <strong>{t("Total Tax")} :</strong> EGP{" "}
                        {selectedOrder?.total_tax_amount?.toFixed(2)}
                      </p>
                    )}
                    {selectedOrder?.delivery_fee > 0 && (
                      <p>
                        <strong>{t("Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.delivery_fee?.toFixed(2)}
                      </p>
                    )}

                    {selectedOrder?.return_delivery_fee < 0 && (
                      <p>
                        <strong>{t("Refunded Delivery Fee :")}</strong> EGP{" "}
                        {selectedOrder?.return_delivery_fee?.toFixed(2)}
                      </p>
                    )}
                  </>
                )}
                <p>
                  <strong>{t("Total Amount :")}</strong> EGP{" "}
                  {(selectedOrder?.subtotal < 0
                    ? selectedOrder?.subtotal -
                      Math.abs(selectedOrder?.return_delivery_fee)
                    : selectedOrder?.subtotal +
                    selectedOrder?.return_delivery_fee +
                    selectedOrder?.delivery_fee 
                  ).toFixed(2)}
                </p>
                <div className="flex flex-row justify-between">
                  <div>
                    <p>
                      <strong>{t("Number of Items :")}</strong>{" "}
                      {selectedOrder?.items}
                    </p>
                    <p>
                      <strong>{t("Payment Type :")}</strong>{" "}
                      {t(selectedOrder?.payment)}
                    </p>
                    {selectedOrder?.state === "Unpaid" &&
                    !areAllProductsRefundedOrNegative() ? (
                      <p>
                        <strong>{t("Payment Status :")}</strong> {t("Unpaid")}
                      </p>
                    ) : (
                      !areAllProductsRefundedOrNegative() &&
                      selectedOrder.state === "Paid" && (
                        <p>
                          <strong>{t("Payment Status :")}</strong> {t("Paid")}
                        </p>
                      )
                    )}
                  </div>
                  {selectedOrder?.state === "Unpaid" &&
                  !areAllProductsRefundedOrNegative() ? (
                    <button
                      // onClick={() => setIsUnpaidModalVisible(true)}
                      onClick={() => {
                        setSelectedOrderDetails(selectedOrder); // Set the selected order details
                        setIsUnpaidModalVisible(true);
                      }}
                      className="flex justify-center items-center w-[26vh] py-2 h-[10vh] font-semibold hover:font-semibold text-white bg-[#F42020] border border-solid border-stone-300 whitespace-nowrap rounded-lg cursor-pointer"
                    >
                      <div className="justify-center items-center">
                        {t("Collect Payment")}
                      </div>
                    </button>
                  ) : (
                    !areAllProductsRefundedOrNegative() &&
                    selectedOrder.state === "Paid"&&  (
                      <RefundOrderButton onClick={ReturnButtonClick} />
                    )
                  )}
                  {/* {!areAllProductsRefundedOrNegative() && selectedOrder.state === "paid" && (
                    <RefundOrderButton onClick={handleReturnClick} />
                  )} */}
                </div>
                {!areAllProductsRefundedOrNegative() &&
                  selectedOrder?.state != "Unpaid" &&  (
                    <div className="flex items-center mb-2 mt-5">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={selectAll}
                        className="w-5 h-5 accent-[#1B4597]"
                      />
                      <label className="ms-2">{t("Select All")}</label>
                    </div>
                  )}
              </div>
              {loading ? (
                <div className="px-5">
                  <OrderSkeleton />
                </div>
              ) : (
                // h-[62%]----- previously
                <div className="mt-6 px-5 overflow-y-auto h-[58%] custom-scrollbar">
                  {orderLines?.map((product, index) => {
                    const refundQtyForProduct =
                      refundItems?.find(
                        (prod) => prod.product_id === product.product_id
                      )?.qty || 0;
                    return (
                      <ProductList
                        key={index}
                        selectedOrder={selectedOrder}
                        refundQtyForProduct={refundQtyForProduct}
                        selectAllClick={() =>
                          handleSelectAll({ target: { checked: !selectAll } })
                        }
                        product={{
                          id: product.product_id,
                          name: product.name,
                          image: product.image_url,
                          size:
                            product.variants[0]?.Size ||
                            product.variants[0]?.Type ||
                            "",
                          pack_qty: product.pack_qty,
                          quantity: product.qty,
                          rate: product.price,
                          currency: product.currency,
                          uom: product.uom,
                          available_refund_qty: product?.available_refund_qty,
                          pack_id: product?.package_id,
                          discount_amount:product?.discount_amount/(product.qty >= 0 ? product.qty : -product.qty),
                          tax_id:product?.tax_id,
                          tax_amount:(product?.tax_amount),
                          tax_rate_percent:product?.tax_rate_percent,
                          is_tax_price_inclusive:product?.is_tax_price_inclusive,
                          hamper_id: product?.hamper_id ? product?.hamper_id : null
                        }}
                        isChecked={
                          selectedProducts[product.product_id] || false
                        }
                        onCheckboxChange={handleProductCheckboxChange(
                          product.product_id
                        )}
                        updateRefundItems={updateRefundItems}
                        isProductSelect={index === selectedProductIndex}
                      />
                    );
                  })}
                  <div className="flex flex-row w-full absolute bottom-2 end-2 justify-center items-center mt-10 font-semibold text-lg">
                    {showResendButton && orderLines[0]?.uniq_code_pos && (
                      <ResendButton onClick={handleResetClick} />
                    )}

                      <InvoiceButton
                        width={selectedOrder?.customer_phone ? "half" : "full"}
                        onClick={handleInvoiceClick}
                      />
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </>
  );
}

export default Order_Table;

// import Navbar from "../../components/Navbar/Navbar";
// import ShimmerLoader from "../../loading";
// import "../../styles.css";
// import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import LoadingSpinner from "../../components/Loading";
// import SearchBox from "../../components/CustomWidgets/SearchBox";
// import { debounce } from "@mui/material";
// import axiosInstance from "../../AxiosInstance";
// import { URLS } from "../../API/API endpoints";
// import i18next from "i18next";
// import { toast } from "react-toastify";
// import moment, { lang } from "moment";
// import { checkPermission } from "../../Utils/permissionHelper";
// import { Plus } from "lucide-react";
// import HampersTable from "./HampersTable";
// import CreateHamper from "./CreateHampers";
// import { Breadcrumb, Drawer } from "antd";
// import { DoubleRightOutlined } from "@ant-design/icons";

// const AllHampers = () => {
//   const { t, i18n } = useTranslation();
//   const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
//   const [loading, setloading] = useState(false);
//   const [data, setData] = useState([]);
//   const [currentLimit, setCurrentLimit] = useState(10); // Default limit
//   const [currentOffset, setCurrentOffset] = useState(0); // Default offset
//   const [mainLoading, setMainLoading] = useState(false);
//   const [query, setquery] = useState("");
//   const [allHampers, setAllHampers] = useState([]);
//   const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
//     const [showComponent, setShowComponent] = useState(false);
//     const [editRecord, setEditRecord] = useState(null)
//   const [drawerVisible, setDrawerVisible] = useState(false);
//   const [hamperLines, setHamperLines] = useState([]);
//   const [drawerData, setDrawerData] = useState(null);
//   const [drawerLoading, setDrawerLoading] = useState(false);

//   const company_id = useSelector(
//     (state) => state?.login?.user?.result?.company_id,
//   );
//   const userData = useSelector((state) => state?.login?.user?.result);

//   useEffect(()=>{
//     GetAllHampers();
//   },[])
// const GetAllHampers = async()=>{

//       try {
//     const payload = {
//       company_id: userData?.company_id,
//       limit:currentLimit,
//       offset:currentOffset
//     };
//     const res = await axiosInstance.post(URLS.GET_ALL_HAMPERS, payload);
//       if(res?.data?.result[0]?.status_code == 200){
//     setAllHampers(res?.data?.result[0]?.data)
//       }else{
//         setAllHampers([])
//       }
//     } catch (error) {
//         console.error("Error fetching KPI data:", error);
//         // setloading(false);
//       } finally {
//         // setLoading(false);
//       }
// }

//   const handleRowClick = async (order) => {
//     setDrawerVisible(true);
//     setDrawerLoading(true);
//     setDrawerData(order);

//     console.log("vdfggv", order);

//     try {
//       const payload = {
//         company_id:company_id,
//         hamper_id: order.hamper_id,
//         lang: i18n.language === "ar" ? "ar_001" : "en_US",
//       };
//       const res = await axiosInstance.post(URLS.GET_HAMPER_ITEMS, payload);

//       if (res?.data?.result[0]?.status_code === 200) {
//         setHamperLines(res?.data?.result[0]?.data || []);
//       } else {
//         setHamperLines([]);
//       }
//     } catch (error) {
//       console.error("Error fetching order lines:", error);
//     } finally {
//       setDrawerLoading(false);
//     }
//   };

//   const onClose = () => {
//     setDrawerVisible(false);
//     setHamperLines([]);
//     setDrawerData(null)
//   };

//   const handleDeleteHamper = async(row)=>{
//         const payload = {
//       company_id: company_id,
//       hamper_id: row?.hamper_id, // id from the GetProductTaxes
//       is_delete: true,
//     };
//     try {
//       const res = await axiosInstance.post(URLS.UPDATE_HAMPER_DETAILS, payload);
//       const res1 = res?.data;
//       if (res1?.result[0]?.status_code === 200) {
//         toast.success(t("Hamper deleted successfully"));
//         GetAllHampers();
//       } else {
//         toast.error(t(res1?.result?.status));
//       }
//     } catch (error) {
//       console.error("Error fetching KPI data:", error);
//     } finally {
//     }
//   }
 
//   return (
//     <>
//       {mainLoading && <LoadingSpinner />}

//       <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
//         <Navbar heading="Add Product Taxes" />
//            <div className="font-extrabold mb-3 mx-5">
//                         <Breadcrumb
//                             separator={<DoubleRightOutlined />}
//                             items={
//                                 showComponent
//                                     ? [
//                                         {
//                                             title: (
//                                                 <span
//                                                     className="cursor-pointer hover:bg-gray-200 hover:text-black"
//                                                     onClick={() => setShowComponent(false)}
//                                                 >
//                                                     {t("All Hampers")}
//                                                 </span>
//                                             ),
//                                             key: "All-Hampers",
//                                         },
//                                         {
//                                             title:  t("Create Hamper"),
//                                             key: "create-hamper",
//                                             // title: t("Create Branch"),
//                                             // key: "create-branch",
//                                         },
//                                     ]
//                                     : []
//                             }
//                             className="relative mt-3 font-semibold"
//                         />
//                     </div>
//         <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
//           {/* <div className="font-extrabold mb-3"></div> */}

//           <div className=" mt-3">
//             {!showComponent && 
//             <div className="flex justify-between items-center">

//             <div className="flex gap-x-2 items-center">
//                <SearchBox
//                           showBarcode={true}
//                           searchResult={(values) => {
//                             setquery(values);
//                           }}
//                           placeholder={t("Search Hampers")
//                           }
//                           width={"300px"}
//                           value={query}
//                         />
                        
//             </div>
//              <div className=" flex justify-end mt-3 mx-8">
//               <button
//                 className="w-32 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg mx-2 flex items-center justify-center gap-2"
//                 // onClick={() => setCreateOpen(true)}
//                 onClick={() => {
//                   if (checkPermission("/pos/hampers", isGinne)) {
//                     setShowComponent(true)
//                   }
//                 }}
//               >
//                 <Plus style={{ fontSize: "1.5em", MozMarginStart: -10 }} />
//                 <span>{t("Create")}</span>
//               </button>
//             </div>
           
//             </div>
//             }

//             {loading ? (
//               <ShimmerLoader />
//             ) : (
//               <>
//                 {!showComponent ? (
//                 <HampersTable
//                   additionalData={allHampers}
//                   pagination={(values) => {
//                     setCurrentLimit(values.limit);
//                     setCurrentOffset(values.offset);
//                   }}
//                   onRowClick={handleRowClick}
// handleEditClick={(row)=>{
//     setEditRecord(row)
//     setShowComponent(true)
// }}
// DeleteProductTax={handleDeleteHamper}
//                 />
//                 ) : (
//                     <CreateHamper 
//                     onClose={()=>{setShowComponent(false)
//                         setEditRecord(null)
//                     }}
//                     handleReferesh={()=>{
//                         setCurrentLimit(10);
//                         setCurrentOffset(0);
//                         GetAllHampers();
//                    } } 
//                    editRecord={editRecord}/>
//                 )}
//               </>
//             )}
//           </div>
//         </div>
//            <Drawer
//         title={i18n.language == 'ar' ? drawerData?.arabic_name  : drawerData?.english_name}
//         placement={i18n.language === "ar" ? "left" : "right"}
//         width={500}
//         onClose={onClose}
//         visible={drawerVisible}
//         styles={{
//           header: {
//             color: "#1E3ABA", // Change this to your desired color
//             fontWeight: "bold",
//             fontSize: "20px",
//           },
//         }}
//       >
//         {drawerLoading ? (
//           <div className="space-y-4 p-4">
//             {/* Header Skeleton */}
//             <div className="h-6 bg-gray-200 rounded animate-pulse w-1/2"></div>

//             {/* Summary Skeleton */}
//             <div className="space-y-2">
//               <div className="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
//               <div className="h-4 bg-gray-200 rounded animate-pulse w-2/3"></div>
//               <div className="h-4 bg-gray-200 rounded animate-pulse w-1/2"></div>
//             </div>

//             {/* Product Line Skeletons */}
//             {[1, 2, 3].map((_, idx) => (
//               <div
//                 key={idx}
//                 className="flex items-center space-x-3 border rounded-lg bg-white p-3 shadow-sm animate-pulse"
//               >
//                 <div className="w-10 h-10 bg-gray-200 rounded"></div>
//                 <div className="flex-1 space-y-2">
//                   <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//                   <div className="h-3 bg-gray-200 rounded w-1/2"></div>
//                 </div>
//                 <div className="h-4 bg-gray-200 rounded w-10"></div>
//               </div>
//             ))}
//           </div>
//         ) : // <LoadingSpinner />
//           // <div>{t("Loading order details...")}</div>
//           hamperLines?.length > 0 ? (
//             <div className="space-y-4">
//               {/* Order Summary */}
//               {/* <div className="space-y-1 text-sm font-medium">
//                 <p>
//                   <strong>{t("Order Value :")}</strong> {drawerData.currency}{" "}
//                   {drawerData.order_value}
//                 </p>
//                 <p>
//                   <strong>{t("Total Amount :")}</strong> {drawerData.currency}{" "}
//                   {drawerData.order_value}
//                 </p>
//                 <p>
//                   <strong>{t("Number of Items :")}</strong> {drawerData.items}
//                 </p>
//                 <p>
//                   <strong>{t("Payment Mode :")}</strong>{" "}
//                   {drawerData.payment || "-"}
//                 </p>
//                 <p>
//                   <strong>{t("Payment Status :")}</strong>{" "}
//                   {drawerData.state || "-"}
//                 </p>
//               </div> */}

//               {/* Product Lines */}
//               <div>
//                 {hamperLines.map((line, index) => (
//                   <div
//                     key={index}
//                     className="flex justify-between items-center border rounded-lg bg-white p-2 mb-2 shadow-sm"
//                   >
//                     {/* Image */}
//                     {/* <img
//                       src={line.image_url || "/placeholder.png"}
//                       alt={line.name}
//                       className="w-10 h-10 object-contain rounded"
//                     /> */}

//                     {/* Middle content: Name + Qty x Price */}
//                     <div className="flex flex-col flex-1 mx-2">
//                       <p className="font-semibold text-sm leading-tight">
//                         {line.product_name}
//                       </p>
//                       <p className="text-xs text-gray-600">
//                         {line.qty_added} x EGP {line.sale_price.toFixed(2)} 
//                       </p>
//                     </div>

//                     {/* Right: Total price */}
//                     <p className="font-normal whitespace-nowrap text-right">
//                       EGP {(line.sale_price * line.qty_added).toFixed(2)}
//                     </p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ) : (
//             <p className="text-center">{t("no_product_found")}</p>
//           )}
//       </Drawer>
//       </div>

//     </>
//   );
// };

// export default AllHampers;






















// import React, { useState, useCallback, useEffect } from "react";
// import {
//   SearchOutlined,
//   DeleteOutlined,
//   DownloadOutlined,
//   CloseOutlined,
// } from "@ant-design/icons";
// import Navbar from "../../components/Navbar/Navbar";
// import { toast } from "react-toastify";
// import axiosInstance from "../../AxiosInstance";
// import { t } from "i18next";
// import {
//   Input,
//   DatePicker,
//   Select,
//   Breadcrumb,
//   AutoComplete,
//   Image,
// } from "antd";
// import { InputBox } from "../../components/CustomWidgets/InputBox";
// import { URLS } from "../../API/API endpoints";
// import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
// import UploadMediaonly from "../../components/upload-imageonly";
// import LoadingSpinner from "../../components/Loading";

// /* -------------------------------------------
//    COMPONENT
// --------------------------------------------*/
// const CreateHamper = ({ onClose, handleReferesh, editRecord }) => {
//   const { t, i18n } = useTranslation();
//   const userData = useSelector((state) => state?.login?.user?.result);
//   const [hamperNameEn, setHamperNameEn] = useState(
//     editRecord ? editRecord?.english_name : "",
//   );
//   const [hamperNameAr, setHamperNameAr] = useState(
//     editRecord ? editRecord?.arabic_name : "",
//   );
//   const [barcode, setBarcode] = useState(editRecord ? editRecord?.barcode : "");
//   const [imageFile, setImageFile] = useState(null);
//   const [imageURL, setImageURL] = useState(
//     editRecord?.image_url ? editRecord?.image_url : null,
//   );

//   const [searchValue, setSearchValue] = useState("");
//   const [searchByShortCode, setSearchByShortCode] = useState(false);

//   const [productList, setProductList] = useState([]);
//   const [originalProducts, setOriginalProducts] = useState([]);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const [Productoptions, setProductoptions] = useState([]);
//   const [value, setValue] = useState("");
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [selectedProductId, setSelectedProductId] = useState(null);
//   const [isFileValid, setIsFileValid] = useState(true);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (imageFile && isFileValid === false) {
//       // getInventoryKPI();
//       setImageFile("");
//       setImageURL("");
//     }
//   }, [isFileValid, imageFile]);

//   useEffect(() => {
//     if (editRecord?.hamper_id) {
//       GetHamperProducts(editRecord);
//     }
//   }, [editRecord]);

//   const GetHamperProducts = async (order) => {
//     try {
//       const payload = {
//         company_id: userData?.company_id,
//         hamper_id: order.hamper_id,
//         lang: i18n.language === "ar" ? "ar_001" : "en_US",
//       };
//       const res = await axiosInstance.post(URLS.GET_HAMPER_ITEMS, payload);

//       if (res?.data?.result[0]?.status_code === 200) {
//         setProductList(res?.data?.result[0]?.data || []);
//         setOriginalProducts(res?.data?.result[0]?.data || []);
//       } else {
//         setProductList([]);
//         setOriginalProducts([]);
//       }
//     } catch (error) {
//       console.error("Error fetching order lines:", error);
//     } finally {
//       //   setDrawerLoading(false);
//     }
//   };

//   /* -------------------------------------------
//      SEARCH PRODUCTS (DEBOUNCE)
//   --------------------------------------------*/
//   const debounce = (func, delay) => {
//     let timer;
//     return (...args) => {
//       clearTimeout(timer);
//       timer = setTimeout(() => func(...args), delay);
//     };
//   };

//   const searchProducts = useCallback(
//     debounce(async (value) => {
//       getProducts(value);
//     }, 500),
//     [],
//   );

//   const getProducts = async (val = "") => {
//     //   setLoading(true);
//     try {
//       const payload = {
//         user_id: userData?.user_id,
//         company_id: userData?.company_id,
//         category_id: false,
//         product_name: val,
//         limit: 10,
//         offset: 0,
//         lang: i18n.language === "ar" ? "ar_001" : "en_US",
//       };
//       const res = await axiosInstance.post(URLS.GET_ALL_PRODUCTS, payload);
//       //   console.log("PRIODYCYD", res);

//       const result = res?.data?.result[0]?.response || [];
//       setProductoptions(result);
//     } catch (err) {
//       console.error("Error fetching products:", err);
//       setProductoptions([]);
//     } finally {
//       // setLoading(false);
//     }
//   };

//   /* -------------------------------------------
//      ADD PRODUCT
//   --------------------------------------------*/
//   const handleProductSelect = (value) => {
//     const selectedProduct = Productoptions.find(
//       (product) => product.product_name === value,
//     );

//     if (selectedProduct) {
//       // Check if the product has a barcode
//       if (!selectedProduct.barcode) {
//         // If no barcode, open the modal to input the barcode
//         setSelectedProduct(selectedProduct);
//         setSelectedProductId(selectedProduct.quant_id);
//         return; // Exit the function to prevent adding the product
//       }
//     }

//     if (selectedProduct) {
//       // Check if the product is already in the productList
//       const isDuplicate = productList.some(
//         (product) => product.quant_id === selectedProduct.quant_id, // Assuming prod_id is unique
//       );

//       if (isDuplicate) {
//         // Optionally, show a message to the user
//         toast.error(`${selectedProduct.product_name} is already in the list.`); // Replace with a more user-friendly message or modal if needed
//         return;
//       }

//       const productWithQty = {
//         ...selectedProduct,
//       };
//       setSelectedProduct(productWithQty);
//       setProductList([...productList, productWithQty]);
//       // setSearchQuery("");
//       // setProductoptions([]);
//     }
//   };

//   /* -------------------------------------------
//      CHANGE PRODUCT FIELD
//   --------------------------------------------*/
//   const handleChange = (index, key, value) => {
//     const updated = [...productList];
//     updated[index][key] = value;
//     setProductList(updated);
//   };

//   /* -------------------------------------------
//      REMOVE PRODUCT
//   --------------------------------------------*/
//   const handleDelete = (id) => {
//     const updated = productList.filter(
//       (p) => p.product_id !== id && p.quant_id !== id,
//     );

//     setProductList(updated);
//   };

//   /* -------------------------------------------
//      IMAGE UPLOAD
//   --------------------------------------------*/

//   /* -------------------------------------------
//      SAVE HAMPER
//   --------------------------------------------*/
//   const handleSave = async () => {
//     try {
//       if (!hamperNameEn || !hamperNameAr) {
//         toast.error(t("Enter hamper name"));
//         return;
//       }

//       if (productList.length === 0) {
//         toast.error(t("Add at least one product"));
//         return;
//       }

//       const missingFields = productList.find(
//         (p) =>
//           p.sale_price === "" ||
//           p.sale_price === null ||
//           p.sale_price === undefined ||
//           Number(p.sale_price) <= 0 ||
//           p.qty_added === "" ||
//           p.qty_added === null ||
//           p.qty_added === undefined ||
//           Number(p.qty_added) <= 0,
//       );

//       if (missingFields) {
//         toast.error(t("Sale price and quantity are required for all items"));
//         return;
//       }

//       const invalidSalePrice = productList.find(
//         (p) => Number(p.sale_price) < Number(p.current_cost_price),
//       );

//       if (invalidSalePrice) {
//         toast.error(t("Sale price cannot be less than cost price"));
//         return;
//       }

//       // ❌ Qty added must not exceed available qty
//       const invalidQty = productList.find(
//         (p) => Number(p.qty_added) > Number(p.system_quantity),
//       );

//       if (invalidQty) {
//         toast.error(t("Quantity cannot exceed available stock"));
//         return;
//       }
//       setLoading(true);
//       const totalCost = productList.reduce(
//         (sum, p) =>
//           sum + Number(p.current_cost_price || 0) * Number(p.qty_added || 0),
//         0,
//       );

//       const totalSalePrice = productList.reduce(
//         (sum, p) => sum + Number(p.sale_price || 0) * Number(p.qty_added || 0),
//         0,
//       );
//       const payload = {
//         company_id: userData?.company_id,
//         english_name: hamperNameEn,
//         arabic_name: hamperNameAr,
//         barcode,
//         image_url: imageURL,
//         total_cost: Number(totalCost),
//         sale_price: Number(totalSalePrice),
//         items: productList.map((p) => ({
//           product_id: p.quant_id,
//           cost_price: Number(p.current_cost_price),
//           qty_available: Number(p.system_quantity),
//           sale_price: Number(p.sale_price),
//           qty_added: Number(p.qty_added),
//         })),
//       };
//       const res = await axiosInstance.post(URLS.CREATE_HAMPER, payload);
//       if (res?.data?.result[0]?.status_code == 200) {
//         toast.success(t(res?.data?.result[0]?.status));
//         handleCancel();
//         handleReferesh();
//       } else {
//         toast.error(t(res?.data?.result[0]?.status));
//       }
//     } catch (error) {
//       console.error("Error fetching KPI data:", error);
//       // setloading(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpdateHamper = async () => {
//     try {
//       if (!hamperNameEn || !hamperNameAr) {
//         toast.error(t("Enter hamper name"));
//         return;
//       }

//       if (productList.length === 0) {
//         toast.error(t("Add at least one product"));
//         return;
//       }

//       const missingFields = productList.find(
//         (p) =>
//           p.sale_price === "" ||
//           p.sale_price === null ||
//           p.sale_price === undefined ||
//           Number(p.sale_price) <= 0 ||
//           p.qty_added === "" ||
//           p.qty_added === null ||
//           p.qty_added === undefined ||
//           Number(p.qty_added) <= 0,
//       );

//       if (missingFields) {
//         toast.error(t("Sale price and quantity are required for all items"));
//         return;
//       }

//       const invalidSalePrice = productList.find(
//         (p) => Number(p.sale_price) < Number(p.current_cost_price),
//       );

//       if (invalidSalePrice) {
//         toast.error(t("Sale price cannot be less than cost price"));
//         return;
//       }

//       // ❌ Qty added must not exceed available qty
//       const invalidQty = productList.find(
//         (p) => Number(p.qty_added) > Number(p.system_quantity),
//       );

//       if (invalidQty) {
//         toast.error(t("Quantity cannot exceed available stock"));
//         return;
//       }
//       setLoading(true);
//       const totalCost = productList.reduce(
//         (sum, p) =>
//           sum + Number(p.current_cost_price || 0) * Number(p.qty_added || 0),
//         0,
//       );

//       const totalSalePrice = productList.reduce(
//         (sum, p) => sum + Number(p.sale_price || 0) * Number(p.qty_added || 0),
//         0,
//       );

//       const deletedItems = originalProducts
//         .filter(
//           (op) => !productList.some((p) => p.product_id === op.product_id),
//         )
//         .map((op) => ({
//           id: op.id, // important for backend
//           product_id: op.product_id ? op.product_id : op.quant_id,
//           cost_price: op.cost_price
//             ? Number(op.cost_price)
//             : Number(op.current_cost_price || 0),
//           qty_available: op.qty_available
//             ? Number(op.qty_available)
//             : Number(op.system_quantity || 0),
//           sale_price: Number(op.sale_price || 0),
//           qty_added: Number(op.qty_added || 0),
//           is_delete: true,
//         }));

//       const payload = {
//         company_id: userData?.company_id,
//         hamper_id: editRecord?.hamper_id,
//         english_name: hamperNameEn,
//         arabic_name: hamperNameAr,
//         barcode,
//         image_url: imageURL,
//         total_cost: Number(totalCost),
//         sale_price: Number(totalSalePrice),
//         items: [
//           ...productList.map((p) => ({
//             ...(p.id && { id: p.id }),
//             product_id: p.product_id ? p.product_id : p.quant_id,
//             cost_price: p.cost_price
//               ? Number(p.cost_price)
//               : Number(p.current_cost_price),
//             qty_available: p.qty_available
//               ? Number(p.qty_available)
//               : Number(p.system_quantity),
//             sale_price: Number(p.sale_price),
//             qty_added: Number(p.qty_added),
//             is_delete: false,
//           })),
//           ...deletedItems,
//         ],
//       };
//       console.log("payload==>", payload);

//       const res = await axiosInstance.post(URLS.UPDATE_HAMPER_DETAILS, payload);
//       if (res?.data?.result[0]?.status_code == 200) {
//         toast.success(t(res?.data?.result[0]?.status));
//         handleCancel();
//         handleReferesh();
//       } else {
//         toast.error(t(res?.data?.result[0]?.status));
//       }
//     } catch (error) {
//       console.error("Error fetching KPI data:", error);
//       // setloading(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* -------------------------------------------
//      CANCEL
//   --------------------------------------------*/
//   const handleCancel = () => {
//     setHamperNameEn("");
//     setHamperNameAr("");
//     setBarcode("");
//     setProductList([]);
//     setImageFile(null);
//     setImageURL(null);
//     onClose();
//   };

//   const isSalePriceInvalid = (p) =>
//     Number(p.sale_price) < Number(p.current_cost_price);

//   const isQtyInvalid = (p) => Number(p.qty_added) > Number(p.system_quantity);

//   return (
//     <div className="w-full min-h-screen bg-[#F6F7F9]">
//       {/* Header */}
//       <div className="flex justify-between items-center px-6 mt-4">
//         <h2 className="text-xl font-semibold">{t("Create Hamper")}</h2>
//         {loading && <LoadingSpinner />}
//         <div className="flex gap-3">
//           <button
//             onClick={handleCancel}
//             className="px-6 h-10 border rounded-lg bg-white"
//           >
//             {t("Cancel")}
//           </button>

//           <button
//             onClick={() => {
//               if (editRecord) {
//                 handleUpdateHamper();
//               } else {
//                 handleSave();
//               }
//             }}
//             className="px-6 h-10 rounded-lg bg-primaryBlue text-white"
//           >
//             {t("Save")}
//           </button>
//         </div>
//       </div>

//       {/* Card */}
//       <div className="bg-white mx-6 my-4 p-6 rounded-lg border">
//         {/* Top Row */}
//         <div className="flex gap-6">
//           <div className="w-9/12">
//             <div className=" flex justify-between gap-x-3">
//               <span className="block leading-[0px] w-4/12">
//                 <InputBox
//                   label={t("Hamper Name (EN)")}
//                   //   className={`${
//                   //     formik.errors.secondaryBarcode ? "border-red" : ""
//                   //   }`}
//                   name="englishName"
//                   placeholder={t("Enter Hamper Name")}
//                   onChange={(e) => {
//                     setHamperNameEn(e.target.value);
//                   }}
//                   value={hamperNameEn}
//                   maxLength={30}
//                 />
//               </span>
//               <span className="block leading-[0px] w-4/12">
//                 <InputBox
//                   label={t("Hamper Name (AR)")}
//                   //   className={`${
//                   //     formik.errors.secondaryBarcode ? "border-red" : ""
//                   //   }`}
//                   name="arabicName"
//                   placeholder={t("Enter Arabic Name")}
//                   onChange={(e) => {
//                     setHamperNameAr(e.target.value);
//                   }}
//                   value={hamperNameAr}
//                   maxLength={30}
//                 />
//               </span>
//               <span className="block leading-[0px] w-4/12">
//                 <InputBox
//                   label={t("Barcode")}
//                   // type="number"
//                   name="arabicName"
//                   placeholder={t("Enter Barcode")}
//                   onChange={(e) => {
//                     let value = e.target.value;
//                     if (/^\d*$/.test(value)) {
//                       setBarcode(value);
//                     }
//                   }}
//                   value={barcode}
//                   maxLength={14}
//                 />
//               </span>
//             </div>
//             <div className="w-full flex mt-10">
//               <span className="relative w-full">
//                 <AutoComplete
//                   value={value}
//                   style={{ width: "100%", height: "43px", outline: "none" }}
//                   open={dropdownOpen}
//                   onDropdownVisibleChange={(open) => setDropdownOpen(open)}
//                   options={Productoptions?.map((prod) => ({
//                     value: prod.product_name,
//                     label: (
//                       <div className="flex justify-between items-center">
//                         <span>{prod.product_name}</span>
//                         {productList.some(
//                           (p) => p.quant_id === prod.quant_id,
//                         ) && (
//                           <svg
//                             width="14"
//                             height="14"
//                             viewBox="0 0 24 24"
//                             fill="none"
//                             stroke="#16A34A"
//                             strokeWidth="3"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           >
//                             <polyline points="20 6 9 17 4 12" />
//                           </svg>
//                         )}
//                       </div>
//                     ),
//                     disabled: productList.some(
//                       (p) => p.quant_id === prod.quant_id,
//                     ),
//                   }))}
//                   filterOption={false}
//                   onSearch={(val) => {
//                     setValue(val);
//                     if (searchByShortCode) {
//                       if (val.length >= 1) {
//                         // handleSearchShortCode(val);
//                       } else {
//                         setProductoptions([]);
//                       }
//                     } else {
//                       if (val.length >= 2) {
//                         searchProducts(val);
//                         setDropdownOpen(true); // keep open while typing
//                       } else {
//                         setProductoptions([]);
//                         setDropdownOpen(false);
//                       }
//                     }
//                   }}
//                   onSelect={(val) => {
//                     handleProductSelect(val);
//                     setValue("");

//                     // Delay a tick to reopen dropdown
//                     setTimeout(() => setDropdownOpen(true), 0);
//                   }}
//                 >
//                   <Input
//                     placeholder={
//                       searchByShortCode
//                         ? t("Search Short Code")
//                         : t("search_product")
//                     }
//                     size="large"
//                     style={{
//                       borderColor: "#d9d9d9", // remove border
//                       boxShadow: "none", // remove hover/focus glow
//                     }}
//                     suffix={
//                       value ? (
//                         <CloseOutlined
//                           onClick={() => {
//                             setValue("");
//                             setDropdownOpen(true); // keep dropdown open after clearing
//                           }}
//                           style={{ cursor: "pointer" }}
//                         />
//                       ) : (
//                         <SearchOutlined />
//                       )
//                     }
//                   />
//                 </AutoComplete>
//               </span>
//               {/* <button
//                     type="button"
//                     onClick={() => {
//                       setValue("");
//                       setProductoptions([]);
//                       setSearchByShortCode(!searchByShortCode);
//                     }}
//                     className="h-[40px] px-3 mx-3 rounded-md border border-primaryBlue text-sm bg-white whitespace-nowrap"
//                   >
//                     {searchByShortCode
//                       ? t("Search by Name")
//                       : t("Search by Code")}
//                   </button> */}
//             </div>
//           </div>
//           {/* Upload */}
//           <div className=" w-3/12 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer">
//             {imageURL ? (
//               <img
//                 src={imageURL}
//                 height={100}
//                 width={100}
//                 alt="prod"
//                 style={{
//                   minWidth: "17rem",
//                   maxWidth: "18rem",
//                   maxHeight: "13rem",
//                   minHeight: "12rem",
//                 }}
//               />
//             ) : imageFile ? (
//               <img
//                 src={imageFile}
//                 height={100}
//                 width={100}
//                 alt="Uploaded"
//                 style={{
//                   minWidth: "17rem",
//                   maxWidth: "18rem",
//                   maxHeight: "13rem",
//                   minHeight: "12rem",
//                 }}
//               />
//             ) : (
//               <svg
//                 className=" float-left h-10 w-12 text-gray-300"
//                 viewBox="0 0 24 24"
//                 fill="currentColor"
//                 aria-hidden="true"
//               >
//                 <path
//                   fill-rule="evenodd"
//                   d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
//                 />
//               </svg>
//             )}
//             <span className="cursor-pointer">
//               <UploadMediaonly
//                 foldername={"store_image"}
//                 onfileAdd={"Productrequest"}
//                 setBase64Images={setImageFile}
//                 urlgenerated={(val) => setImageURL(val?.url)}
//                 imageurl={imageURL ? imageURL : ""}
//                 setIsFileValid={setIsFileValid}
//               />
//             </span>
//           </div>
//           {/* <div className=" w-3/12 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer">
//             <DownloadOutlined className="text-xl text-primaryBlue mb-1" />

//             <p className="text-primaryBlue font-medium">
//               {t("Upload Hamper Image")}
//             </p>

//             <span className="text-xs text-gray-400">{t("(Optional)")}</span>

//             <input type="file" hidden onChange={handleImage} />
//           </div> */}
//         </div>

//         {/* Search */}

//         {/* Table */}
//         {productList.length > 0 && (
//           <div className="border rounded-lg mt-8">
//             <table className="w-full text-sm text-gray-800">
//               <thead className="bg-gray-100">
//                 <tr className="font-medium">
//                   <th className="p-3 text-left font-medium text-gray-900">
//                     {t("Barocde")}
//                   </th>
//                   <th className="p-3 text-left font-medium text-gray-900">
//                     {t("Product Name")}
//                   </th>
//                   <th className="p-3 text-left w-[140px] font-medium text-gray-900">
//                     {t("Cost Price")}
//                   </th>
//                   <th className="p-3 text-left w-[140px] font-medium text-gray-900">
//                     {t("Qty Available")}
//                   </th>
//                   <th className="p-3 w-[120px] font-medium text-gray-900">
//                     {t("Sale Price")}
//                   </th>

//                   <th className="p-3 w-[120px font-medium text-gray-900]">
//                     {t("Qty Added")}
//                   </th>
//                   <th className="p-3 font-medium text-gray-900">
//                     {t("Action")}
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {productList.map((p, i) => (
//                   <tr key={i} className="border-t">
//                     <td className="p-3">{p.barcode}</td>
//                     <td className="p-3 ">
//                       {p.product_name2 && p.product_name2 != ""
//                         ? p.product_name2
//                         : p.product_name}
//                     </td>
//                     <td className="p-3 w-[140px]">
//                       EGP{" "}
//                       {p.cost_price
//                         ? p.cost_price.toFixed(2)
//                         : p.current_cost_price.toFixed(2)}
//                     </td>
//                     <td className="p-3 w-[140px]">
//                       {p.qty_available || p.system_quantity}
//                     </td>
//                     <td className="p-3 w-[120px]">
//                       <Input
//                         value={p.sale_price}
//                         status={isSalePriceInvalid(p) ? "error" : ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (
//                             value == "" ||
//                             (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 5)
//                           ) {
//                             handleChange(i, "sale_price", e.target.value);
//                           }
//                         }}
//                       />
//                     </td>

//                     <td className="p-3 w-[120px]">
//                       <Input
//                         value={p.qty_added}
//                         status={isQtyInvalid(p) ? "error" : ""}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           if (
//                             value === "" ||
//                             (p.uom !== "Units" &&
//                               p.uom != "الوحدات" &&
//                               /^\d*\.?\d{0,3}$/.test(value) ||
//                       ((p.uom === "Units" || p.uom != "الوحدات") &&
//                         /^[0-9]*$/.test(value) &&
//                         value.length <= 6))
//                           ) {
//                             handleChange(i, "qty_added", value);
//                           }
//                         }}
//                       />
//                     </td>

//                     <td className="p-3 text-center">
//                       <DeleteOutlined
//                         onClick={() =>
//                           handleDelete(
//                             p?.product_id ? p?.product_id : p?.quant_id,
//                           )
//                         }
//                         className="text-red-500 cursor-pointer"
//                       />
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CreateHamper;

















// import React, { useEffect, useMemo, useState } from "react";
// import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
// import "tailwindcss/tailwind.css";
// import { Empty } from "antd";
// import "../../styles.css";
// import Vectorsorting from "../../assets/Vectorsorting.svg";
// import ShimmerLoader from "../../loading";
// import { useTranslation } from "react-i18next";
// import { Navigate, useNavigate } from "react-router-dom";
// import CustomPagination from "../../components/CustomWidgets/CustomPagination";
// import { useSelector } from "react-redux";
// import arrowright from "../../assets/arrowright.svg";
// import Edit from "../../assets/Edit.svg";
// import deleteicon from "../../assets/Order/Delete.svg";

// const HampersTable = ({ additionalData, pagination, showDrawer, onRowClick ,DeleteProductTax ,handleEditClick }) => {
//   const { t, i18n } = useTranslation();
//   const [flag, setflag] = useState(false);
//   const navigate = useNavigate();

//   const allStores = useSelector(
//     (state) => state?.storeReducer?.selectedStore?.is_select_all_store
//   )


//   const openOrderList = (id) => {
//     // console.log("CREDIT CUS TOME id", id);

//     // navigate(`/customerCreditOrder?id=${id}`);
//   };

//   const data = useMemo(
//     () =>
//       //   additionalData?.status
//       //     ? additionalData?.all_product
//       additionalData || [],
//     [additionalData]
//   );


//   useEffect(() => {
//     if (additionalData?.length === 0 && !flag) {
//       const timer = setTimeout(() => {
//         setflag(true);
//       }, 3000);

//       return () => clearTimeout(timer);
//     }
//   }, [additionalData, flag]);



//   const columns = useMemo(
//     () => [
//       {
//         Header: (
//           <div className="text-start justify-start" title={t("Hamper")}>
//             {t("English Name")}
//           </div>
//         ),
//         width: "20%", // Add this line
//         accessor: "english_name",
//         headerClassName: "text-start",
//         Cell: ({ row }) => (
//           <div className="text-start justify-start">{row.original.english_name}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start justify-start" title={t("Hamper")}>
//             {t("Arabic Name")}
//           </div>
//         ),
//         width: "20%", // Add this line

//         accessor: "arabic_name",
//         headerClassName: "text-start",
//         Cell: ({ row }) => (
//           <div className="text-start justify-start">{row.original.arabic_name}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Items")}>
//             {t("Items")}
//           </div>
//         ),
//         width: "20%",
//         accessor: "items",
//         Cell: ({ row }) => (
//           <div className="text-start">{row.original.items}</div>
//         ),
//       },
//       {
//         Header: (
//           <div className="text-start" title={t("Sales Value")}>
//             {t("Sales Value")}
//           </div>
//         ),
//         width: "20%", // Add this line
//         accessor: "sale_price",
//         Cell: ({ row }) => (
//           <div className="text-start">{row.original.sale_price}</div>
//         ),
//       },
//       {
//               Header: t("Actions"),
//               accessor: "actions",
//               width: "15%",
//               Cell: ({ row }) => (
//                 <div className="flex gap-2 justify-start">
//                   <img
//                     src={Edit}
//                     className="cursor-pointer h-4 w-4"
//                     alt="Edit"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       handleEditClick(row.original);
//                     }}
//                   />
//                   <img
//                     src={deleteicon}
//                     className="cursor-pointer h-4 w-4 mx-2"
//                     alt="Delete"
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       DeleteProductTax(row.original);
//                     }}
//                   />
//                 </div>
//               ),
//             },
//       {
//               id: "action",
//               Header: "",
//               headerClassName: "text-start",
//               // width: 50,
//               width: "10%", // Add this line
//               accessor: (row) =>
//                 `${row.original},`,
//               Cell: ({ row }) => (
//                 <>
//                   <button
//                     className=" text-[#1b4497] rounded-lg"
//                   // onClick={() => openOrderList(row.original.order_details.order_no)}
//                   >
//                     <img
//                       src={arrowright}
//                       alt="arrowright"
//                       className={`${i18n.language == "en" ? "" : " rotate-180"}`}
//                       height={3}
//                       width={20}
//                     />
//                   </button>
//                   {/* )
//                         } */}
//                 </>
//               ),
//             },
//       // {
//       //   Header: (
//       //     <div className="text-start" title={t("Created On")}>
//       //       {t("Created On")}
//       //     </div>
//       //   ),
//       //   accessor: "credit_amount",
//       //   Cell: ({ row }) => (
//       //     <div className="text-start">{`EGP ${row.original.credit_amount}`}</div>
//       //   ),
//       // },
//     ],
//     [t]
//   );


//   const {
//     headerGroups,
//     prepareRow,
//     page,
//     nextPage,
//     setPageSize,
//     state: { pageSize },
//   } = useTable(
//     {
//       columns,
//       data: data,
//       initialState: { pageSize: 10 },
//     },
//     useSortBy,
//     usePagination,
//     useRowSelect
//   );

//   const [pageIndex, setpageIndex] = useState(1);

//   useEffect(() => {
//     const pageDetails = {
//       limit: pageSize,
//       offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
//     };

//     if (pageSize) pagination(pageDetails);
//   }, [pageSize, pageIndex]);


//   const handlePageSizeChange = (newPageSize) => {
//     // Ensure the current page doesn't exceed the total available pages
//     const maxPageIndex = Math.ceil(data.length / newPageSize);
//     if (pageIndex > maxPageIndex) {
//       setpageIndex(maxPageIndex); // Adjust the pageIndex to the last available page
//     }

//     setPageSize(newPageSize);
//   };


//   return (
//     <>
//       <div
//         className="container flex flex-col mx-auto mt-4"
//         style={{ maxWidth: "100%" }}
//       >
//         {additionalData?.length == 0 && flag == false ? (
//           <div className="h-screen w-[90%] mt-2 ">
//             <ShimmerLoader />
//           </div>
//         ) : (
//           <>
//             {/* Header Table (Fixed) */}
//             <div>
//               <table
//                 className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
//                 style={{ tableLayout: "fixed" }}
//               >
//                 <thead>
//                   {headerGroups.map((headerGroup, headerIndex) => {
//                     const { key: headerKey, ...headerGroupProps } =
//                       headerGroup.getHeaderGroupProps();
//                     return (
//                       <tr
//                         key={headerKey}
//                         {...headerGroupProps}
//                         className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
//                       >
//                         {headerGroup.headers.map((column, colIndex) => {
//                           const { key: columnKey, ...columnProps } =
//                             column.getHeaderProps(
//                               column.getSortByToggleProps()
//                             );
//                           return (
//                             <th
//                               key={columnKey}
//                               {...columnProps}
//                               className="py-3 whitespace-nowrap"
//                               style={{ width: column.width }} // Set column width
//                             >
//                               <div className="flex items-start ms-2 text-sm ">
//                                 {column.render("Header")}
//                                 <span className="">
//                                   {column.isSorted ? (
//                                     column.isSortedDesc ? (
//                                       <img
//                                         src={Vectorsorting}
//                                         style={{ minHeight: 10, minWidth: 10 }}
//                                         alt="vector"
//                                       />
//                                     ) : (
//                                       <img
//                                         className="rotate-180"
//                                         src={Vectorsorting}
//                                         alt="vector"
//                                       />
//                                     )
//                                   ) : (
//                                     ""
//                                   )}
//                                 </span>
//                               </div>
//                             </th>
//                           );
//                         })}
//                       </tr>
//                     );
//                   })}
//                 </thead>
//               </table>
//             </div>

//             {/* Body Table (Scrollable) */}
//             <div
//               className="scrollbar-none bg-white"
//               style={{
//                 overflowY: "auto",
//                 maxHeight: "450px", // Adjust height as needed
//               }}
//             >
//               <table
//                 className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
//                 style={{ tableLayout: "fixed" }}
//               >
//                 <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
//                   {page.map((row) => {
//                     prepareRow(row);
//                     return (
//                       <React.Fragment key={row.id}>
//                         <tr
//                           {...row.getRowProps()}
//                           className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
//                            onClick={() => onRowClick && onRowClick(row.original)}
//                         >
//                           {row.cells.map((cell, index) => (
//                             <td
//                               key={index}
//                               {...cell.getCellProps()}
//                               className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
//                                 } ${cell?.column?.Header == "Product"
//                                   ? "cursor-pointer"
//                                   : ""
//                                 }`}
//                               style={{ width: cell.column.width }} // Match column width
//                             >
//                               {cell.render("Cell")}
//                             </td>
//                           ))}
//                         </tr>
//                       </React.Fragment>
//                     );
//                   })}
//                   {page.length === 0 && (
//                     <tr>
//                       <td colSpan={"100%"}>
//                         <Empty
//                           className="mt-10"
//                           description={t("No data available")}
//                         />
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//             {/* Pagination */}
//             <div className="">
//               <CustomPagination
//                 data={data?.length}
//                 pageIndex={pageIndex}
//                 pageCount={page?.length}
//                 canPreviousPage={pageIndex != 1 ? true : false}
//                 canNextPage={data?.length == pageSize ? true : false}
//                 gotoPage={(page) => {
//                   nextPage(page);
//                 }}
//                 previousPage={() => {
//                   setpageIndex(pageIndex - 1);
//                 }}
//                 nextPage={() => {
//                   setpageIndex(pageIndex + 1);
//                 }}
//                 pageSize={pageSize}
//                 setPageSize={handlePageSizeChange}

//               // setPageSize={(pageSize) => {
//               //   setPageSize(pageSize);
//               // }}
//               />
//             </div>
//           </>
//         )}
//       </div>
//     </>
//   );
// };

// export default HampersTable;







 // Hampers APIS
//   CREATE_HAMPER:"/Store/2/CreateHamper",
//   GET_ALL_HAMPERS:"/Store/2/GetHampers",
//   GET_HAMPER_ITEMS:"/Store/2/GetHamperItems",
//  UPDATE_HAMPER_DETAILS:"/Store/2/UpdateHamper",